import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const Newsletter = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Mock subscription
      toast.success('Thank you for subscribing to SOLENNE');
      setEmail('');
    }
  };

  return (
    <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
          <h2 className="hero-medium" style={{ marginBottom: '16px' }}>Join Our Circle</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '40px' }}>
            Receive exclusive access to new collections, private events, and artisan stories.
          </p>
          
          <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              required
              className="body-regular"
              style={{
                flex: '1',
                minWidth: '280px',
                padding: '19px 23px',
                border: '1px solid var(--border-medium)',
                borderRadius: '0px',
                background: 'transparent',
                color: 'var(--text-primary)',
                outline: 'none',
                transition: 'border-color 0.2s ease'
              }}
            />
            <button type="submit" className="btn-primary">
              Subscribe
              <ArrowRight size={16} style={{ marginLeft: '8px' }} />
            </button>
          </form>
          
          <p className="body-small" style={{ marginTop: '16px', color: 'var(--text-light)' }}>
            We respect your privacy and will never share your information.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
